module.exports = __webpack_public_path__ + "static/media/cert8.54542dde.png";